import * as Sentry from '@sentry/react';
import PropTypes from 'prop-types';
import React from 'react';

import { propTypesDataGridWithMainLines } from './GridWithMainLines.proptypes';

import Text, { TextAppearance } from '../../../../ui/Atoms/Text';

import * as S from './GridWithMainLines.styles';

const renderHeadlineRow = (headline, items, key) => {
  if (!headline || !key) {
    return null;
  }

  return (
    <>
      <S.StyledRow>
        <S.StyledSuperTitle colSpan={`${items?.length}`}>
          <Text>{headline}</Text>
        </S.StyledSuperTitle>
      </S.StyledRow>
      <S.StyledRow>
        {items.map((item, index) => {
          const title = item[`${key}_title`] || '';

          return <S.StyledTitle key={index}>{title}</S.StyledTitle>;
        })}
      </S.StyledRow>
      <S.StyledRow>
        {items.map((item, index) => {
          const content = item[`${key}_content`]?.html || '';

          return (
            <S.StyledContent key={index}>
              <Text type={TextAppearance.INFO}>{content}</Text>
            </S.StyledContent>
          );
        })}
      </S.StyledRow>
    </>
  );
};

export const GridWithMainLinesSlice = ({ slice }) => {
  if (!slice) {
    return null;
  }

  const data = slice.primary || {};

  const {
    grid_main_lines_slice_id: id,
    first_headline: { html: firstHeadline },
    second_headline: { html: secondHeadline },
  } = data || '';

  const items = slice.items;
  if (items?.length < 2) {
    Sentry.captureMessage(
      'Error: missing required data in GridWithMainLines slice'
    );
    return null;
  }

  return (
    <S.Wrapper id={id}>
      {renderHeadlineRow(firstHeadline, items, 'first')}
      {renderHeadlineRow(secondHeadline, items, 'second')}
    </S.Wrapper>
  );
};

GridWithMainLinesSlice.propTypes = {
  /**
   * Content of the GridWithMainLines slice.
   */
  slice: PropTypes.shape(propTypesDataGridWithMainLines),
};
